import {
  TOGGLE_COMPETITOR_STATUS_REQUEST,
  TOGGLE_COMPETITOR_STATUS_SUCCESS,
  TOGGLE_COMPETITOR_STATUS_FAILURE,
} from "../actions/competitorStatusActions";

const initialState = {
  loading: false,
  success: false,
  error: null,
};

const competitorStatusReducer = (state = initialState, action) => {
  switch (action.type) {
    case TOGGLE_COMPETITOR_STATUS_REQUEST:
      return {
        ...state,
        loading: true,
        success: false,
        error: null,
      };

    case TOGGLE_COMPETITOR_STATUS_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
      };

    case TOGGLE_COMPETITOR_STATUS_FAILURE:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.error,
      };

    default:
      return state;
  }
};

export default competitorStatusReducer;
